<template>
  <div>
    <b-row class="mb-3 ml-2">
      <span class="title_detalle">{{ title }}</span>
    </b-row>

    <b-row>
      <b-col>
        <b-table
          v-if="detalles"
          :fields="fields"
          :items="detalles"
          :empty-text="$t('label.noData')"
          hover
          ref="tableDetalleTransferencia"
          show-empty
          small
          borderless
        >
          <template #cell(actions-left)="row">
            <div class="table-button-container d-flex">
              <b-icon
                :id="`info-detalle-${tipo}-${row.item.id}`"
                class="icon-details ml-3 my-auto cursor-pointer"
                icon="exclamation-circle"
                :alt="$t('label.informacion')"
              />
              <b-tooltip
                :target="`info-detalle-${tipo}-${row.item.id}`"
                custom-class="table-cell-tooltip"
                placement="bottom"
              >
                <template
                  v-for="(detalleDemanda, index) in tipo === 'OFERTA'
                    ? row.item.detallesDemanda
                    : row.item.detallesOferta"
                >
                  <div :key="`detalle-${detalleDemanda.id}`">
                    <hr v-if="index" class="m-0" />

                    <div class="tooltip-inner-content-diff">
                      <div class="title-info">
                        {{ $t("label.denominacion") }}:
                        {{ detalleDemanda.soCalidadDenominacion.denominacion.codDenominacion }}
                        {{ detalleDemanda.soCalidadDenominacion.desCalidad }}
                      </div>
                      <hr
                        v-if="
                          (tipo === 'OFERTA' && row.item.detallesDemanda.length === 1) ||
                          (tipo !== 'OFERTA' && row.item.detallesOferta.length === 1)
                        "
                        class="m-0 pt-2"
                      />
                      <div v-if="tipo == 'OFERTA'">
                        {{ $t("label.demandado") }}:
                        {{ filterNumber(detalleDemanda.cantidadDisponible, 2) }}
                      </div>
                      <div v-else>
                        {{ $t("label.ofertado") }}:
                        {{ filterNumber(detalleDemanda.cantidadDisponible, 2) }}
                      </div>
                    </div>
                  </div>
                </template>
              </b-tooltip>
              <b-icon
                :id="`transferir-${tipo}-${row.index}`"
                class="icon-details ml-3 my-auto cursor-pointer"
                icon="arrow-left-right"
                v-b-tooltip.hover.d300="
                  tipo === 'OFERTA' ? $t('label.transferir') : $t('label.demandar')
                "
                :alt="tipo === 'OFERTA' ? $t('label.transferir') : $t('label.demandar')"
                @click="
                  tipo === 'OFERTA' ? relacionarDemanda(row.item) : relacionarOferta(row.item)
                "
              />
            </div>
          </template>
          <template #cell(coste)="row">
            {{ $t(`label.coste.${row.value.codParametro}`) }}
          </template>
          <template #cell(checkParcial)="row">
            {{ $t(`label.${row.value ? "yes" : "no"}`) }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import VueFilters from "@/vue-filters";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { IField, ITransferencia, IOfertaDemanda } from "@/entities";

@Component({
  name: "detalle-transferencia",
  mixins: [VueFilters],
})
export default class TransferenciasCompatibles extends Vue {
  @Prop({ required: true }) ofertaDemanda!: IOfertaDemanda;
  @Prop({ required: true }) tipo!: "OFERTA" | "DEMANDA";
  @Action("fetchDemandasCompatibles") fetchDemandasCompatibles!: (
    id: number
  ) => Promise<IOfertaDemanda[] | undefined>;
  @Action("fetchOfertasCompatibles") fetchOfertasCompatibles!: (
    id: number
  ) => Promise<IOfertaDemanda[] | undefined>;

  @Action("setLoading") setLoading!: (loading: boolean) => void;

  detalles: IOfertaDemanda[] = [];

  get title(): string {
    return this.tipo === "OFERTA"
      ? this.$t("label.demandasCompatibles")
      : this.$t("label.ofertasCompatibles");
  }

  get fields(): IField[] {
    const columns = [
      {
        key: "actions-left",
        label: this.$t("label.acciones"),
        sortable: false,
        thClass: "table-header ml-2",
        tdClass: "table-cell-first actions",
        visible: true,
        class: "table-cell",
        aux: true,
      },
      {
        key: "clientexdel.cliente.desCliente",
        label: this.$t("label.cliente"),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        visible: true,
        class: "table-cell",
        aux: false,
      },
      {
        key: "cantidadDisponible",
        label: this.$t("label.cantidad"),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        visible: true,
        class: "table-cell",
        formatter: (value: number, key: string, item: ITransferencia): string => {
          if (item.estado === "ACEPTADA") return this.filterNumber(item.cantidadTransferida, 2);
          else return this.filterNumber(value, 2);
        },
        aux: false,
      },
      {
        key: "coste.desParametro",
        label: this.$t("label.coste"),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        visible: true,
        class: "table-cell",
        aux: false,
      },
      {
        key: "checkParcial",
        label: this.$t("label.parcial"),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        visible: true,
        class: "table-cell",
        aux: false,
      },
      {
        key: "estado",
        label: this.$t("label.estado"),
        sortable: true,
        thClass: "table-header",
        tdClass: (value: string): string => "table-cell-middle " + value.toLowerCase(),
        visible: true,
        class: "table-cell",
        aux: false,
      },
    ];

    if (this.tipo === "DEMANDA") {
      return columns.filter(function (value) {
        return value.key != "checkParcial";
      });
    }
    return columns;
  }
  constructor() {
    super();
  }
  mounted(): void {
    this.fetch();
  }

  relacionarDemanda(demanda: IOfertaDemanda): void {
    this.$emit("relacionarDemanda", { demandaCompatible: demanda, oferta: this.ofertaDemanda });
  }

  relacionarOferta(oferta: IOfertaDemanda): void {
    this.$emit("relacionarOferta", { ofertaCompatible: oferta, demanda: this.ofertaDemanda });
  }

  async fetch(): Promise<void> {
    if (this.tipo === "OFERTA") {
      const response = await this.fetchDemandasCompatibles(this.ofertaDemanda.id);
      if (response) {
        this.detalles = response;
      }
    } else {
      const response = await this.fetchOfertasCompatibles(this.ofertaDemanda.id);
      if (response) {
        this.detalles = response;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title_detalle {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
  margin-top: 10px;
}
</style>
